module.exports = __webpack_public_path__ + "img/page4.8bda2bd7.svg";